import "core-js/modules/es.object.to-string.js";
import _interopRequireWildcard from "C:/project/\u6587\u5316\u5BAB/code/whg/Web/Web/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/interopRequireWildcard";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { fetchListByType } from '@/api/PMS/dic/dic';
import { fetchList, fetchDelete } from '@/api/PMS/customerService/attarctCustorme';
import waves from '@/directive/waves'; // 水波纹指令

import { formatJson } from '@/utils/index';
import add from './add';
export default {
  directives: {
    waves: waves
  },
  components: {
    add: add
  },
  data: function data() {
    return {
      id: null,
      title: '',
      dialogFormVisible: false,
      customStatusOption: [],
      saleStatusOption: [],
      sourceStatusOption: [],
      list: null,
      total: null,
      listLoading: false,
      listQuery: {
        page: 1,
        limit: 10
      },
      multipleSelection: [],
      datePicker: null,
      pickerOptions: {
        shortcuts: [{
          text: '今天',
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一周',
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一个月',
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近三个月',
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近半年',
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 180);
            picker.$emit('pick', [start, end]);
          }
        }]
      }
    };
  },
  created: function created() {
    this.loadCustomStatusOption();
    this.loadsourceStatusOption();
    this.loadSaleStatusOption();
    this.getList();
  },
  methods: {
    loadCustomStatusOption: function loadCustomStatusOption() {
      var _this = this;

      fetchListByType('attract_status').then(function (r) {
        _this.customStatusOption = r.data.data;
      });
    },
    loadsourceStatusOption: function loadsourceStatusOption() {
      var _this2 = this;

      fetchListByType('channel_type').then(function (r) {
        _this2.sourceStatusOption = r.data.data;
      });
    },
    loadSaleStatusOption: function loadSaleStatusOption() {
      var _this3 = this;

      fetchListByType('sales_status').then(function (r) {
        _this3.saleStatusOption = r.data.data;
      });
    },
    getList: function getList() {
      var _this4 = this;

      this.listLoading = true;

      if (this.datePicker !== null && this.datePicker.length > 0) {
        this.listQuery.beginDate = this.datePicker[0];
        this.listQuery.endDate = this.datePicker[1];
      } else {
        this.listQuery.beginDate = '';
        this.listQuery.endDate = '';
      }

      fetchList(this.listQuery).then(function (response) {
        _this4.list = response.data.data;
        _this4.total = response.data.total;
        _this4.listLoading = false;
      });
    },
    handleFilter: function handleFilter() {
      this.listQuery.page = 1;
      this.getList();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.listQuery.limit = val;
      this.getList();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.listQuery.page = val;
      this.getList();
    },
    handleSelectionChange: function handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    handleDelete: function handleDelete(id) {
      var _this5 = this;

      this.$confirm('你确定是要删除这条招商客户信息, 是否继续?', '提示').then(function () {
        var query = {
          attractId: id
        };
        fetchDelete(query).then(function (response) {
          _this5.getList();

          _this5.Alert({
            alertType: 'delete'
          });
        });
      });
    },
    handleCreate: function handleCreate() {
      this.id = -1;
      this.title = '新增客户';
      this.dialogFormVisible = true;
    },
    handleEdit: function handleEdit(id) {
      this.id = id;
      this.title = '编辑客户';
      this.dialogFormVisible = true;
    },
    handCancle: function handCancle(reload) {
      if (reload) {
        this.getList();
      }

      this.dialogFormVisible = false;
    },
    handleExport: function handleExport() {
      var _this6 = this;

      this.$confirm('你确定要导出招商客户记录吗, 是否继续?', '提示').then(function () {
        if (_this6.list !== null && _this6.list.length > 0) {
          Promise.resolve().then(function () {
            return _interopRequireWildcard(require('@/vendor/Export2Excel'));
          }).then(function (excel) {
            var tHeader = ['客户姓名', '所属行业', '联系人', '联系电话', '来访时间', '客户需求', '意向房源', '来源渠道', '客户状态', '销售阶段', '备注'];
            var fileterVal = ['attractName', 'industryName', 'linkman', 'linkmanPhone', 'attractDate', 'attractDemand', 'houseCodes', 'channelTypeName', 'attractStatusName', 'salesStatusName', 'remark'];
            var data = formatJson(fileterVal, _this6.list);
            excel.export_json_to_excel({
              header: tHeader,
              data: data,
              filename: '招商客户记录',
              autoWidth: true,
              bookType: 'xlsx'
            });
          });
        } else {
          _this6.Alert({
            alertType: 'error',
            message: '暂无数据，无法导出！'
          });
        }
      });
    }
  }
};